import { createSubstore } from 'storeon-substore';
import { Store } from 'store/types';
import { getRelatedServices } from './related-services-actions';
import { FETCH_RELATED_SERVICES, RELATED_SERVICES_STORE_NAME } from './related-services-constants';
import { RelatedService, RelatedServicesStore } from './related-services-types';

const INITIAL_STATE: RelatedServicesStore = {
  serviceList: null,
  loading: false,
  error: null,
} as const;

export const relatedServices = (parentStore: Store) => {
  const store = createSubstore(parentStore, RELATED_SERVICES_STORE_NAME);
  store.on('@init', () => INITIAL_STATE);
  store.on(FETCH_RELATED_SERVICES.init, async (_, categoryId) => {
    const { loading } = store.get();
    const { modelJson } = parentStore.get();
    if (!modelJson.model || loading) {
      return Promise.resolve();
    }
    store.dispatch(FETCH_RELATED_SERVICES.request);

    try {
      const serviceList: RelatedService[] = [];
      const requestIdList = Array.isArray(categoryId) ? categoryId : [categoryId];
      const responseList = await Promise.allSettled(requestIdList.map(id => (
        getRelatedServices(
          parentStore,
          id,
          modelJson.model?.properties?.regionId || ''
        ))));

      responseList.forEach(response => {
        if (response.status === 'fulfilled') {
          serviceList.push(...response.value);
        }
      });

      store.dispatch(FETCH_RELATED_SERVICES.success, serviceList);
    } catch (e) {
      store.dispatch(FETCH_RELATED_SERVICES.failure, (e as Error).message);
    }

    return Promise.resolve();
  });
  store.on(FETCH_RELATED_SERVICES.request, state => ({ ...state, loading: true }));
  store.on(FETCH_RELATED_SERVICES.failure, (state, error) => ({
    ...state,
    error,
    loading: false,
    serviceList: null,
  }));
  store.on(FETCH_RELATED_SERVICES.success, (state, res) => ({ ...state, serviceList: res, loading: false }));
};
